import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import type EstimateValues from "../../../types/params"

const isValidHardGoldOnPCIEdgeTerminal = (values: EstimateValues, surfaceFinishing?: string) => {
  const isApplicableHardGoldOnPCIEdgeTerminal =
    values.surfaceFinishing === ESTIMATE_CONSTANT.表面処理["有鉛はんだレベラー(リジッド)"].value ||
    values.surfaceFinishing === ESTIMATE_CONSTANT.表面処理["水溶性フラックス(リジッド)"].value ||
    values.surfaceFinishing === ESTIMATE_CONSTANT.表面処理["無鉛はんだレベラー(リジッド)"].value

  switch (surfaceFinishing) {
    case ESTIMATE_CONSTANT.端子部のみ電解金めっき.する.value:
      return isApplicableHardGoldOnPCIEdgeTerminal
    case ESTIMATE_CONSTANT.端子部のみ電解金めっき.しない.value:
      return true

    default:
      return false
  }
}

export default isValidHardGoldOnPCIEdgeTerminal
